import { ViewerComponent } from "./Landing";

const ComplaintResolution = () => {
    return   <div style={{ marginTop: 0, backgroundColor: '#fff', paddingTop: '20px', height: '100vh', borderRadius: '10px' }}>
        <div style={{display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 10}}><span>Giải quyết khiếu nại</span></div>
          <ViewerComponent fileUrl={'pdf/giai-quyet-khieu-nai.pdf'} />
     </div>
}

export default ComplaintResolution;